import dayjs from 'dayjs';

export const formatCreationDate = (createdAt: string) =>
  createdAt ? dayjs(createdAt).format('MM/DD/YY [at] HH:MM a') : 'N/A';
